





















































import { Component, Vue } from 'vue-property-decorator';

@Component({})
export default class HeroBanner extends Vue {
  private mounted() {
    window.addEventListener('scroll', this.scrollEvent);
  }

  private destroyed() {
    window.removeEventListener('scroll', this.scrollEvent);
  }

  private scrollEvent() {
    const background = this.$refs.background as HTMLDivElement;
    background.style.backgroundPosition = `50% calc(50% - ${-(window.pageYOffset / 3)}px)`;

    const logo = this.$refs.logo as HTMLHeadingElement;
    logo.style.top = `calc(50% - ${-(window.pageYOffset / 4)}px)`;

    const pieces = document.getElementsByClassName('piece');
    for (const piece of pieces) {
      (piece as HTMLDivElement).style.backgroundPosition = `50% calc(50% - ${-(window.pageYOffset / 2)}px)`;
    }
  }
}
